module.exports = __webpack_public_path__ + "assets/webgl/Frame_Painting_normal.1001.jpg.8bb65c11.webp";